export const CANAL_VENTA_ONLINE = 'online';
export const CANAL_VENTA_ASISTIDA = 'asistida';

const PLAN_STATE_KEYS = ['Personas', 'Empresas', 'UrgPlus', 'Conecta'];
const PROMOTOR_QUERY_PARAMS = ['codigoPromotor', 'codPromotor', 'session'];
const PROMOTOR_COOKIE_NAMES = ['codigoPromotor', 'codPromotor', 'promotorName'];

const hasValue = value => {
  if (value === null || value === undefined) return false;

  const normalizedValue = String(value).trim();

  return normalizedValue !== '' && normalizedValue !== 'null' && normalizedValue !== 'undefined';
};

const getQueryParam = key => {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);

  return params.get(key);
};

const getCookieByName = name => {
  if (typeof document === 'undefined') return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop().split(';').shift();

  return null;
};

const hasPromotorInQuery = () => PROMOTOR_QUERY_PARAMS.some(key => hasValue(getQueryParam(key)));

const hasPromotorInCookies = () => PROMOTOR_COOKIE_NAMES.some(key => hasValue(getCookieByName(key)));

const hasPromotorInStore = store => {
  if (!store || !store.state) return false;

  const hasLoggedPromotor = PLAN_STATE_KEYS.some(key => {
    const planState = store.state[key];

    return Boolean(planState && (planState.ItsPromotor || planState.CreatedByPromotor));
  });

  const sources = store.state.Misc && store.state.Misc.Sources;
  const hasPromotorSource = Boolean(sources && (
    hasValue(sources.codigoPromotor) ||
    hasValue(sources.codPromotor)
  ));

  return hasLoggedPromotor || hasPromotorSource;
};

const isGtmSystemEvent = event => String(event).indexOf('gtm.') === 0;

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export const isVentaAsistida = store => (
  hasPromotorInStore(store) ||
  hasPromotorInQuery() ||
  hasPromotorInCookies()
);

export const getCanalVenta = store => (
  isVentaAsistida(store) ? CANAL_VENTA_ASISTIDA : CANAL_VENTA_ONLINE
);

const shouldEnrichPayload = payload => (
  payload &&
  typeof payload === 'object' &&
  !Array.isArray(payload) &&
  hasOwn(payload, 'event') &&
  !hasOwn(payload, 'canal_venta') &&
  !isGtmSystemEvent(payload.event)
);

export const addCanalVentaToPayload = (payload, store) => {
  if (!shouldEnrichPayload(payload)) return payload;

  return Object.assign({}, payload, {
    canal_venta: getCanalVenta(store),
  });
};

export const installCanalVentaDataLayer = store => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  const originalPush = window.dataLayer.push;

  if (originalPush && originalPush.__canalVentaInstalled) return;

  const enrichedPush = function pushWithCanalVenta() {
    const payloads = Array.prototype.slice.call(arguments).map(payload => (
      addCanalVentaToPayload(payload, store)
    ));

    return originalPush.apply(window.dataLayer, payloads);
  };

  enrichedPush.__canalVentaInstalled = true;
  enrichedPush.__originalPush = originalPush;

  window.dataLayer.push = enrichedPush;
};
